import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Ë",
  "use": "icon-Ë-usage",
  "viewBox": "0 0 61 60",
  "content": "<symbol viewBox=\"0 0 61 60\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-Ë\">\n<path d=\"M49.1677 48.904H24.8317V10.648H49.1677V48.904ZM10.9117 10.648H21.3757V48.904H10.9117V10.648ZM50.8957 7.192H9.18366C8.22366 7.192 7.45566 7.96 7.45566 8.92V50.68C7.45566 51.64 8.22366 52.408 9.18366 52.408H50.8957C51.8557 52.408 52.6237 51.64 52.6237 50.68V8.92C52.6237 7.96 51.8557 7.192 50.8957 7.192Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol